module.exports = __webpack_public_path__ + "c004b5a0abaab472aac776cfd30e97ba.ttf";